import script from "./FilesView.vue?vue&type=script&setup=true&lang=js"
export * from "./FilesView.vue?vue&type=script&setup=true&lang=js"

import "./FilesView.vue?vue&type=style&index=0&id=1d278317&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d278317"]])

export default __exports__